import React, { useState, useEffect } from 'react';
import api from '../services/api';
import './AdminAgenda.css';

const AdminAgenda = () => {
    // Guardamos la fecha base para consultar (por defecto hoy)
    const [fechaBase, setFechaBase] = useState(new Date().toISOString().slice(0, 10));
    const [data, setData] = useState({ semana: null, reporte: [] });
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState('');

    useEffect(() => {
        const fetchAusencias = async () => {
            try {
                setLoading(true);
                // Le pasamos la fechaBase al backend para que calcule esa semana
                const res = await api.get(`/agenda/admin/ausencias-semana?fecha=${fechaBase}`);
                setData(res.data);
            } catch (err) {
                setError(err.response?.data?.message || 'Error al cargar ausencias');
                console.error(err);
            } finally {
                setLoading(false);
            }
        };
        fetchAusencias();
    }, [fechaBase]);

    // Funciones para navegar entre semanas
    const cambiarSemana = (dias) => {
        // Usamos UTC para evitar saltos por zonas horarias
        const fecha = new Date(fechaBase);
        fecha.setDate(fecha.getDate() + dias);
        setFechaBase(fecha.toISOString().slice(0, 10));
    };

    // Lógica para habilitar/deshabilitar botones
    const obtenerLunes = (fechaStr) => {
        const d = new Date(fechaStr);
        const day = d.getDay(); // 0 es Domingo
        const diff = d.getDate() - day + (day === 0 ? -6 : 1); // Ajuste a Lunes
        return new Date(d.setDate(diff)).toISOString().slice(0, 10);
    };

    const lunesActual = obtenerLunes(new Date().toISOString().slice(0, 10));
    const lunesSeleccionado = obtenerLunes(fechaBase);

    // El botón "Anterior" se deshabilita si el lunes seleccionado es igual o menor al lunes actual
    const puedeRetroceder = lunesSeleccionado > lunesActual;

    // Límite de 4 semanas (28 días) para avanzar
    const lunesLimite = new Date(lunesActual);
    lunesLimite.setDate(lunesLimite.getDate() + 28);
    const puedeAvanzar = lunesSeleccionado < lunesLimite.toISOString().slice(0, 10);

    const formatearFecha = (fechaStr) => {
        if (!fechaStr) return '';
        const [y, m, d] = fechaStr.split('-');
        return `${d}/${m}`;
    };

    const getDiasSemana = (dias) => {
        if (dias.length === 0) return '-';
        if (dias.length > 3) {
            return `Del ${formatearFecha(dias[0])} al ${formatearFecha(dias[dias.length - 1])}`;
        }
        return dias.map(formatearFecha).join(', ');
    };

    const getHorasSemana = (horas) => {
        if (horas.length === 0) return '-';
        const agrupadas = {};
        horas.forEach(h => {
            if (!agrupadas[h.fecha]) agrupadas[h.fecha] = [];
            agrupadas[h.fecha].push(h.hora);
        });
        
        return Object.entries(agrupadas).map(([fecha, hs]) => (
            <div key={fecha} className="hora-grupo">
                <strong>{formatearFecha(fecha)}:</strong> {hs.join(' / ')}
            </div>
        ));
    };

    const getEstadoBadge = (estado) => {
        const map = {
            disponible: { class: 'estado-confirmado', label: '✅ Disponible' },
            parcial: { class: 'estado-pendiente', label: '⏳ Bloqueo Parcial' },
            vacaciones: { class: 'estado-cancelado', label: '❌ Vacaciones' },
        };
        const info = map[estado] || map.parcial;
        return <span className={`turno-badge ${info.class}`}>{info.label}</span>;
    };

    if (loading && !data.reporte.length) {
        return <div className="admin-turnos"><div className="admin-turnos-loading">Cargando ausencias...</div></div>;
    }

    return (
        <div className="admin-turnos">
            <div className="admin-page-header" style={{ marginBottom: '1.5rem' }}>
                <h1>🗓️ Control de Ausencias</h1>
                <p className="admin-page-subtitle">
                    Disponibilidad de los masajistas por semana
                </p>
            </div>

            {error && <div className="alert alert-danger">{error}</div>}

            {/* Navegador de Semanas */}
            <div className="semana-navegador" style={{ 
                display: 'flex', 
                alignItems: 'center', 
                justifyContent: 'space-between', 
                marginBottom: '1.5rem', 
                background: '#FFF9F2', 
                padding: '1rem', 
                borderRadius: '12px',
                border: '1px solid rgba(200, 170, 150, 0.2)'
            }}>
                <button 
                    className="btn btn-secondary" 
                    onClick={() => cambiarSemana(-7)}
                    disabled={!puedeRetroceder} // <--- CORREGIDO
                >
                    ◀ Semana Anterior
                </button>
                
                <div style={{ fontWeight: '600', color: '#4A3729', fontSize: '1.1rem', textAlign: 'center' }}>
                    📅 Semana del {data.semana ? formatearFecha(data.semana.desde) : ''} al {data.semana ? formatearFecha(data.semana.hasta) : ''}
                </div>

                <button 
                    className="btn btn-primary" 
                    onClick={() => cambiarSemana(7)}
                    disabled={!puedeAvanzar} 
                >
                    Semana Siguiente ▶
                </button>
            </div>

            <div className="admin-turnos-lista">
                {data.reporte.length === 0 ? (
                    <div className="empty-state">
                        <div className="empty-state-icon">👥</div>
                        <div className="empty-state-title">No hay masajistas</div>
                        <div className="empty-state-text">No se encontraron masajistas activos</div>
                    </div>
                ) : (
                    <div className="grupo-turnos">
                        <div className="grupo-header">
                            <span className="grupo-etiqueta">
                                👥 Estado de Disponibilidad
                            </span>
                            <span className="grupo-count">
                                {data.reporte.length} profesionales
                            </span>
                        </div>
                        <div className="grupo-tabla">
                            {data.reporte.map((m) => (
                                <div key={m.masajistaId} className="turno-row">
                                    
                                    <div className="turno-col">
                                        <div className="turno-label">Profesional</div>
                                        <div className="turno-valor">{m.nombre} {m.apellido}</div>
                                        <div className="turno-detalle">{m.email}</div>
                                    </div>
                                    
                                    <div className="turno-col">
                                        <div className="turno-label">Días completos</div>
                                        <div className="turno-valor">{getDiasSemana(m.diasCompletos)}</div>
                                    </div>

                                    <div className="turno-col">
                                        <div className="turno-label">Horas bloqueadas</div>
                                        <div className="turno-valor" style={{ fontSize: '0.8rem' }}>
                                            {m.horasParciales.length > 0 ? getHorasSemana(m.horasParciales) : '-'}
                                        </div>
                                    </div>

                                    <div className="turno-col">
                                        <div className="turno-label">Estado</div>
                                        <div>{getEstadoBadge(m.estadoSemana)}</div>
                                    </div>

                                </div>
                            ))}
                        </div>
                    </div>
                )}
            </div>
        </div>
    );
};

export default AdminAgenda;